import { MarketSegmentEnum } from '../../types';
import { getMarketSegment } from '../../utils';
import { Banner as CommonBanner } from '@vfpt/common-fe-components';
import AmigoBanner from './AmigoBanner/AmigoBanner';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function Banner() {
    const isAmigo = getMarketSegment() === MarketSegmentEnum.AMIGO;
    const isMobile = useWindowDimensions().width < 641;

    return isAmigo ? (
        <AmigoBanner />
    ) : (
        <div className="common-banner-no-radius">
            <CommonBanner
                title="Tv Net Voz + Móvel"
                description="Pacotes fibra com 2 números ilimitados e Google One incluído desde €65,5/mês"
                backgroundType="image"
                backgroundColor="black"
                buttonText="Saber mais"
                buttonUrl="https://www.vodafone.pt"
                backgroundImage="https://www.vodafone.pt/content/dam/digital-sites/homepage/homepage-tv-net-voz-widescreen-hb0-1920x500.png"
                sideImage={
                    isMobile
                        ? 'https://www.vodafone.pt/content/dam/digital-sites/homepage/tv-net-voz-super-series-widescreen-mob-640x500.png'
                        : ''
                }
            />
        </div>
    );
}
